import React, { useState, useEffect, useRef } from 'react';
import { Alert, Button, ButtonGroup, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from '../../components/CustomNavbar';
import SidebarConfig from '../../components/SidebarConfig';
import UserVaccinationComponent from '../../components/profile/UserVaccinationComponent';
import {withRouter} from 'react-router-dom';
import UserMenuComponent from '../../components/profile/UserMenuComponent';
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import { getAreas, getCarpetas } from '../../redux/gestorDocumental/actions';
const EmployeesVaccines = props => {
  //* States
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  //*Ref
  const childRef = useRef();

  //* Redux
  const dispatch = useDispatch();
  const {userInfo, loadingFicha_Empleado} = useSelector(store => store.employees);
  const { areas, carpetas, loadingAreas, loadingCarpetas, areasError, carpetasError } = useSelector(store => store.gestorDocumental);
  //* Methods
  useEffect(() => {
    dispatch(
      getFuncFichaEmpleado(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
    dispatch(getAreas());
    dispatch(getCarpetas());
  }, []);
  
  return (
    <>
      <CustomNavbar  type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1">
            <h2 className="font-weight-bold d-flex justify-content-between align-items-center text-uppercase">{ props.match.params.name }
              <ButtonGroup>
                <Button
                  onClick={props.history.goBack}
                  size="sm"><i className="material-icons">keyboard_return</i></Button>
                <UserMenuComponent id={props.match.params.id} name={props.match.params.name} type={props.match.params.type} /> 
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => childRef.current.onAdd()}><i className="material-icons">add</i></Button>
              </ButtonGroup>
            </h2>
            <hr />
            <h6>{parseInt(props.type) === 1 ?'Vacunas formal' : 'Vacunas funcional'}</h6>
            {
              areasError || carpetasError ? (
                <Alert variant="danger">
                  {
                    areasError && (areasError)
                  }
                  {
                    carpetasError && (carpetasError)
                  }
                </Alert>
              ) : null
            }
          </div>
          {
            loadingFicha_Empleado || loadingAreas || loadingCarpetas? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center" />
              </div>
            ) : (
              <UserVaccinationComponent
                areas={areas} 
                carpetas={carpetas} 
                ref={childRef} 
                type={props.match.params.type} 
                id={props.match.params.id}
                divicion={userInfo && userInfo.Division_Personal_List ? userInfo.Division_Personal_List[0].descripcion : null}
                empresa={userInfo && userInfo.empresa ? userInfo.empresa[0] : null}
                />
            )
          }
        </div>
      </div>
    </>
  )
}

export default withRouter(EmployeesVaccines)
